import { useState } from "react";
import api from "../lib/api";
import PageHeader, { PageBody, Card, Badge, useFetch } from "../components/Shared";

const EVENT_TONE = {
  HUMAN_ESCALATION: "signal", ROLLBACK: "signal", RECOMMENDATION_REJECTED: "signal",
  RECOMMENDATION_APPROVED: "forest", AGENT_VERSION_ACTIVATED: "forest", HUMAN_RESOLVED: "forest",
  RETURN_TO_AI: "forest", HUMAN_ASSIGNED: "warning", HUMAN_RESPONSE: "warning",
  RECOMMENDATION_CREATED: "neutral", DIAGNOSIS_CREATED: "neutral", AGENT_VERSION_CREATED: "neutral",
};

export default function SupervisorAudit() {
  const { data, loading } = useFetch(() => api.get("/supervisor/audit-logs", { params: { limit: 200 } }).then((r) => r.data), []);
  const items = data?.items || [];
  const [filter, setFilter] = useState("");
  const events = Array.from(new Set(items.map((i) => i.event)));
  const shown = filter ? items.filter((i) => i.event === filter) : items;

  return (
    <>
      <PageHeader label="Inteligencia Conversacional" title="Auditoría"
        description="Registro inmutable de acciones del Supervisor y de la atención humana.">
        <select data-testid="audit-filter" value={filter} onChange={(e) => setFilter(e.target.value)}
          className="bg-white border border-carbon-200 rounded px-3 py-2 text-sm">
          <option value="">Todos los eventos</option>
          {events.map((e) => <option key={e} value={e}>{e.replace(/_/g, " ")}</option>)}
        </select>
      </PageHeader>
      <PageBody>
        {loading ? <div className="text-carbon-500">Cargando...</div> : shown.length === 0 ? (
          <Card className="p-10 text-center text-carbon-500">Sin eventos registrados.</Card>
        ) : (
          <Card className="overflow-hidden" testid="audit-table">
            <table className="w-full text-sm">
              <thead className="bg-page text-[10px] uppercase tracking-wider text-carbon-400">
                <tr>
                  <th className="text-left px-4 py-2">Fecha</th>
                  <th className="text-left px-4 py-2">Evento</th>
                  <th className="text-left px-4 py-2">Usuario</th>
                  <th className="text-left px-4 py-2">Detalle</th>
                </tr>
              </thead>
              <tbody>
                {shown.map((a) => (
                  <tr key={a.id} className="border-t border-carbon-100 align-top" data-testid={`audit-row-${a.id}`}>
                    <td className="px-4 py-2 text-xs text-carbon-500 whitespace-nowrap">{a.timestamp ? new Date(a.timestamp).toLocaleString() : ""}</td>
                    <td className="px-4 py-2"><Badge tone={EVENT_TONE[a.event] || "neutral"}>{(a.event || "").replace(/_/g, " ")}</Badge></td>
                    <td className="px-4 py-2 text-xs">{a.user_email || "sistema"}</td>
                    <td className="px-4 py-2 text-xs text-carbon-600 font-mono max-w-md truncate">{JSON.stringify(a.metadata || {})}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        )}
      </PageBody>
    </>
  );
}
